//CustomFieldsConfiguration For dynamic Field
export class CustomFieldsConfiguration {
    EntityId: number;
    EntityName: string;
    PanelId: number;
    PanelName: string;
    CustomFields: CustomField[];
}

export class ConfigGroup {
    CustomFieldsGroup: CustomField[];
}

export class CustomField {
    CustomFieldId: number;
    CompanyId: number;
    FieldName: string;
    FieldTypeId: number;
    MaxLength: number;
    TooltipText: string;
    PrimaryEntityId: number;
    Description: string;
    IsActive: boolean;
    FieldType: string;
    remarks: string;
    CustomFieldPanelId: number;
    DisplayOrder: number;
    IsMandatory: boolean;
    IsViewable: boolean;
    IsEditable: boolean;
    CustomFieldValueId: number;
    PkId: number;
    Value: any;
    HeadingId: number;
    HeadingName: string;
    customFieldDropdown: CustomFieldDropdown[];
}

export class CustomFieldDropdown {
    CustomDropdownId: number;
    CompanyId: number;
    CustomFieldId: number;
    DropdownId: number;
    DropdownValue: string;
}